module.exports = __webpack_public_path__ + "media/images/logo_action_park-ae91e623e5a0ecd0eda275ed5d799b81.png";